import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const dict = {
  en: {
    app_name: "Asset Inspection",
    tagline: "Daily dump truck chassis inspection for site drivers",
    login_title: "Sign in to your account",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    signing_in: "Signing in...",
    login_failed: "Login failed",
    dashboard: "Dashboard",
    masters: "Master Data",
    companies: "Companies",
    sites: "Sites",
    users: "Users & Roles",
    dump_trucks: "Vehicle/Asset",
    vehicle_list: "Vehicle/Asset List",
    vehicle_categories: "Vehicle/Asset Category",
    vehicle_category: "Vehicle/Asset Category",
    select_vehicle_category: "Select vehicle/asset category",
    inspection_types: "Inspection Types",
    inspection_type: "Inspection Type",
    select_inspection_type: "Select inspection type",
    inspection_categories: "Inspection Categories",
    inspection_items: "Inspection Items",
    transactions: "Transactions",
    inspections: "Inspection Report",
    new_inspection: "New Inspection",
    reports: "Reports",
    recap: "Site Vehicle Recap",
    logout: "Sign out",
    name: "Name",
    code: "Code",
    address: "Address",
    location: "Location",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    search: "Search...",
    no_data: "No data yet",
    confirm_delete_title: "Delete this record?",
    confirm_delete_desc: "This action cannot be undone.",
    deleted: "Deleted",
    saved: "Saved successfully",
    company: "Company",
    site: "Site",
    role: "Role",
    superadmin: "Superadmin",
    company_admin: "Company Admin",
    site_admin: "Site Admin",
    admin: "Admin",
    driver: "Driver",
    mechanic: "Mechanic",
    active: "Active",
    inactive: "Inactive",
    is_active: "Active",
    unit_number: "Unit Number",
    hull_number: "Hull Number",
    plate_number: "Plate Number",
    truck_type: "Truck Type",
    brand: "Brand",
    model: "Model",
    category: "Category",
    description: "Description",
    order: "Order",
    guidance: "Technical Guidance",
    status_options: "Status Options",
    ev_only: "EV only",
    all_types: "ICE & EV",
    select_site: "Select site",
    select_truck: "Select vehicle/asset",
    select_category: "Select category",
    select_company: "Select company",
    select_company_first: "Select a company first",
    select_driver: "Select driver/mechanic",
    inspection_time: "Inspection time",
    km_hm: "KM / HM at inspection",
    started_at: "Started",
    completed_at: "Completed",
    driver_name: "Driver/Mechanic",
    approved_by: "Approved by",
    approval_admin: "Approval Admin",
    submit_inspection: "Submit Inspection",
    submitting: "Submitting...",
    findings_note: "Findings note",
    findings_placeholder: "Describe the finding...",
    add_photo: "Add photo",
    uploading: "Uploading...",
    progress: "Progress",
    items_done: "items checked",
    status: "Status",
    OK: "OK",
    NOT_OK: "Not OK",
    KOROSI: "Corrosion",
    KURANG: "Low",
    LONGGAR: "Loose",
    submitted: "Submitted",
    approved: "Approved",
    rejected: "Rejected",
    pending: "Pending",
    approve: "Approve",
    reject: "Reject",
    admin_note: "Admin note",
    admin_note_placeholder: "Optional remarks for the driver...",
    approval: "Approval",
    approval_saved: "Approval saved",
    date: "Date",
    from: "From",
    to: "To",
    export_csv: "Export CSV",
    export_pdf: "Export PDF",
    exporting_pdf: "Exporting...",
    pdf_open_inspection: "Open this inspection to view photos",
    matrix: "Daily Matrix",
    summary: "Summary",
    total_inspections: "Total Inspections",
    days_inspected: "Days Inspected",
    defects_found: "Defects Found",
    defect_inspections: "With Defects",
    last_inspection: "Last Inspection",
    last_km_hm: "Last KM/HM",
    not_inspected: "Not inspected",
    inspected_ok: "Inspected, all OK",
    has_defects: "Defects found",
    legend: "Legend",
    total_trucks: "Active Vehicles/Assets",
    today_inspections: "Inspections Today",
    defects_today: "Defects Today",
    pending_approval: "Pending Approval",
    recent_inspections: "Recent Inspections",
    view: "View",
    view_all: "View all",
    back: "Back",
    all: "All",
    welcome: "Welcome back",
    inspection_detail: "Inspection Detail",
    defects: "defects",
    items: "items",
    queued: "Queued",
    sync: "Sync",
    sync_done: "Synced",
    sync_offline: "Connect to the network to sync",
    sync_need_online: "Sync while online to download this unit and type",
    pending_sync: "pending",
    last_synced: "Last synced",
    offline: "Offline",
    showing_range: "Showing {from}–{to} of {total}",
    page_prev: "Previous",
    page_next: "Next",
    inspection_saved: "Inspection submitted successfully",
    fill_required: "Please select a vehicle/asset, inspection type, enter KM/HM and check every item",
    walk_hint: "Counter-clockwise walk-around order",
    ice: "ICE",
    ev: "EV",
    start_inspection: "Start inspection",
    start_inspection_desc: "Walk around the unit counter-clockwise and check each item.",
    no_checklist: "No active checklist for this site. Ask your admin to set up inspection items.",
    duration: "Duration",
    min: "min",
    general_note: "General note",
    general_note_placeholder: "Anything else to report?",
    defect_summary: "Defect summary",
    no_defects: "No defects — all items OK",
    photos: "Photos",
    remove: "Remove",
    site_filter: "Site",
    date_range: "Date range",
    role_hint_admin: "Admins can only create Driver accounts for their site.",
    role_hint_site_admin: "Site admins can only create Driver and Mechanic accounts for their site.",
    password_hint: "Leave blank to keep the current password",
    language: "Language",
    loading: "Loading...",
    login_hint: "Demo accounts",
    export_matrix: "Export Matrix CSV",
    export_summary: "Export Summary CSV",
    checked: "Checked",
    quick_actions: "Quick actions",
    type: "Type",
    unit: "Unit",
    filter_status: "Filter status",
    per_item_status: "Status options for this item",
    unit_vin_number: "Unit VIN Number",
    drivetrain_layout: "Drivetrain Layout",
    assigned_items: "Assigned Items",
    assigned_categories: "Assigned Categories",
    manage_items: "Manage items",
    manage_categories: "Manage categories",
    assigned: "Assigned (in order)",
    available: "Available",
    assign: "Assign",
    unassign: "Unassign",
    move_up: "Move up",
    move_down: "Move down",
    no_available: "Nothing left to assign",
    no_assigned: "Nothing assigned yet",
    unassigned: "Unassigned",
    exclude_items: "Exclude items",
    excluded_items: "excluded",
    excluded_items_count: "Excluded items",
    excluded: "Excluded",
    no_excluded: "No items excluded",
    exclude_items_hint: "Excluded items are omitted from this type’s checklist. The vehicle category still defines the pool.",
    select_unit_and_type_hint: "Select a vehicle/asset and inspection type to load the checklist.",
    change_scope_title: "Discard current answers?",
    change_scope_desc: "Changing site, vehicle, or inspection type will discard item statuses, notes, photos, and the general note. KM/HM is kept.",
    discard_answers: "Discard answers",
    vin: "VIN",
    categories_count: "Categories",
    items_count: "Items",
    no_categories_hint: "This vehicle/asset has no inspection categories assigned. Ask your admin to assign categories.",
    take_photo: "Take photo",
    capture: "Capture",
    retake: "Retake",
    use_photo: "Use photo",
    camera_error: "Camera not available. Please allow camera access.",
    flash: "Flash",
    flash_on: "Flash on",
    flash_unavailable: "Flash is not available on this camera.",
    compressing: "Processing...",
    all_items: "All items",
    defect_items: "Defect items",
    photos_purged: "Photos were removed after the 3-month retention period; the inspection record is kept.",
    items_flagged: "items flagged",
    default_ok_hint: "All items start as OK — change the status only where you find an issue.",
    photo_optional: "Photo (optional)",
    my_inspections: "My Inspections",
    draft: "Draft",
    save_progress: "Save progress",
    saving_progress: "Saving...",
    progress_saved: "Progress saved on this device",
    continue_draft: "Continue",
    delete_draft: "Delete draft",
    discard_draft: "Discard draft",
    drafts_on_device: "Drafts on this device",
    draft_missing: "Draft not found on this device",
    leave_inspection_title: "Save this inspection?",
    leave_inspection_desc: "You have an inspection in progress. Save a draft on this device, or discard it.",
    save_draft: "Save draft",
    draft_resumed: "Draft restored on this device",
    gps_unavailable: "GPS unavailable",
    gps_insecure: "GPS needs HTTPS. Open this site with https, or use the Android app.",
    msnm: "m",
  },
  id: {
    app_name: "Inspeksi Aset",
    tagline: "Inspeksi harian chassis dump truck untuk driver site",
    login_title: "Masuk ke akun Anda",
    email: "Email",
    password: "Kata sandi",
    sign_in: "Masuk",
    signing_in: "Memproses...",
    login_failed: "Gagal masuk",
    dashboard: "Beranda",
    masters: "Data Master",
    companies: "Perusahaan",
    sites: "Site",
    users: "Pengguna & Peran",
    dump_trucks: "Kendaraan/Aset",
    vehicle_list: "Daftar Kendaraan/Aset",
    vehicle_categories: "Kategori Kendaraan/Aset",
    vehicle_category: "Kategori Kendaraan/Aset",
    select_vehicle_category: "Pilih kategori kendaraan/aset",
    inspection_types: "Tipe Inspeksi",
    inspection_type: "Tipe Inspeksi",
    select_inspection_type: "Pilih tipe inspeksi",
    inspection_categories: "Kategori Inspeksi",
    inspection_items: "Item Inspeksi",
    transactions: "Transaksi",
    inspections: "Laporan Inspeksi",
    new_inspection: "Inspeksi Baru",
    reports: "Laporan",
    recap: "Rekap Kendaraan Site",
    logout: "Keluar",
    name: "Nama",
    code: "Kode",
    address: "Alamat",
    location: "Lokasi",
    actions: "Aksi",
    add: "Tambah",
    edit: "Ubah",
    delete: "Hapus",
    save: "Simpan",
    saving: "Menyimpan...",
    cancel: "Batal",
    search: "Cari...",
    no_data: "Belum ada data",
    confirm_delete_title: "Hapus data ini?",
    confirm_delete_desc: "Tindakan ini tidak dapat dibatalkan.",
    deleted: "Terhapus",
    saved: "Berhasil disimpan",
    company: "Perusahaan",
    site: "Site",
    role: "Peran",
    superadmin: "Superadmin",
    company_admin: "Admin Perusahaan",
    site_admin: "Admin Site",
    admin: "Admin",
    driver: "Driver",
    mechanic: "Mekanik",
    active: "Aktif",
    inactive: "Nonaktif",
    is_active: "Aktif",
    unit_number: "Nomor Unit",
    hull_number: "Nomor Lambung",
    plate_number: "Nomor Polisi",
    truck_type: "Tipe Truk",
    brand: "Merek",
    model: "Model",
    category: "Kategori",
    description: "Deskripsi",
    order: "Urutan",
    guidance: "Panduan Teknis",
    status_options: "Pilihan Status",
    ev_only: "Hanya EV",
    all_types: "ICE & EV",
    select_site: "Pilih site",
    select_truck: "Pilih kendaraan/aset",
    select_category: "Pilih kategori",
    select_company: "Pilih perusahaan",
    select_company_first: "Pilih perusahaan terlebih dahulu",
    select_driver: "Pilih driver/mekanik",
    inspection_time: "Waktu inspeksi",
    km_hm: "KM / HM saat inspeksi",
    started_at: "Mulai",
    completed_at: "Selesai",
    driver_name: "Driver/Mekanik",
    approved_by: "Disetujui oleh",
    approval_admin: "Admin Penyetuju",
    submit_inspection: "Kirim Inspeksi",
    submitting: "Mengirim...",
    findings_note: "Catatan temuan",
    findings_placeholder: "Jelaskan temuan...",
    add_photo: "Tambah foto",
    uploading: "Mengunggah...",
    progress: "Progres",
    items_done: "item diperiksa",
    status: "Status",
    OK: "OK",
    NOT_OK: "Not OK",
    KOROSI: "Korosi",
    KURANG: "Kurang",
    LONGGAR: "Longgar",
    submitted: "Terkirim",
    approved: "Disetujui",
    rejected: "Ditolak",
    pending: "Menunggu",
    approve: "Setujui",
    reject: "Tolak",
    admin_note: "Catatan admin",
    admin_note_placeholder: "Catatan opsional untuk driver...",
    approval: "Persetujuan",
    approval_saved: "Persetujuan disimpan",
    date: "Tanggal",
    from: "Dari",
    to: "Sampai",
    export_csv: "Ekspor CSV",
    export_pdf: "Ekspor PDF",
    exporting_pdf: "Mengekspor...",
    pdf_open_inspection: "Buka inspeksi ini untuk melihat foto",
    matrix: "Matriks Harian",
    summary: "Ringkasan",
    total_inspections: "Total Inspeksi",
    days_inspected: "Hari Diinspeksi",
    defects_found: "Temuan",
    defect_inspections: "Ada Temuan",
    last_inspection: "Inspeksi Terakhir",
    last_km_hm: "KM/HM Terakhir",
    not_inspected: "Belum diinspeksi",
    inspected_ok: "Diinspeksi, semua OK",
    has_defects: "Ada temuan",
    legend: "Keterangan",
    total_trucks: "Kendaraan/Aset Aktif",
    today_inspections: "Inspeksi Hari Ini",
    defects_today: "Temuan Hari Ini",
    pending_approval: "Menunggu Persetujuan",
    recent_inspections: "Inspeksi Terbaru",
    view: "Lihat",
    view_all: "Lihat semua",
    back: "Kembali",
    all: "Semua",
    welcome: "Selamat datang",
    inspection_detail: "Detail Inspeksi",
    defects: "temuan",
    items: "item",
    queued: "Antrian",
    sync: "Sinkron",
    sync_done: "Tersinkron",
    sync_offline: "Sambungkan jaringan untuk sinkron",
    sync_need_online: "Sinkron saat daring untuk mengunduh unit dan tipe ini",
    pending_sync: "menunggu",
    last_synced: "Terakhir sinkron",
    offline: "Luring",
    showing_range: "Menampilkan {from}–{to} dari {total}",
    page_prev: "Sebelumnya",
    page_next: "Berikutnya",
    inspection_saved: "Inspeksi berhasil dikirim",
    fill_required: "Pilih kendaraan/aset, tipe inspeksi, isi KM/HM, dan periksa semua item",
    walk_hint: "Urutan pergerakan berlawanan arah jarum jam",
    ice: "ICE",
    ev: "EV",
    start_inspection: "Mulai inspeksi",
    start_inspection_desc: "Kelilingi unit berlawanan arah jarum jam dan periksa setiap item.",
    no_checklist: "Belum ada checklist aktif untuk site ini. Minta admin menyiapkan item inspeksi.",
    duration: "Durasi",
    min: "mnt",
    general_note: "Catatan umum",
    general_note_placeholder: "Ada hal lain yang perlu dilaporkan?",
    defect_summary: "Ringkasan temuan",
    no_defects: "Tidak ada temuan — semua item OK",
    photos: "Foto",
    remove: "Hapus",
    site_filter: "Site",
    date_range: "Rentang tanggal",
    role_hint_admin: "Admin hanya dapat membuat akun Driver untuk site-nya.",
    role_hint_site_admin: "Admin site hanya dapat membuat akun Driver dan Mekanik untuk site-nya.",
    password_hint: "Kosongkan untuk mempertahankan kata sandi saat ini",
    language: "Bahasa",
    loading: "Memuat...",
    login_hint: "Akun demo",
    export_matrix: "Ekspor CSV Matriks",
    export_summary: "Ekspor CSV Ringkasan",
    checked: "Diperiksa",
    quick_actions: "Aksi cepat",
    type: "Tipe",
    unit: "Unit",
    filter_status: "Filter status",
    per_item_status: "Pilihan status untuk item ini",
    unit_vin_number: "Nomor VIN Unit",
    drivetrain_layout: "Konfigurasi Penggerak",
    assigned_items: "Item Terpasang",
    assigned_categories: "Kategori Terpasang",
    manage_items: "Atur item",
    manage_categories: "Atur kategori",
    assigned: "Terpasang (berurutan)",
    available: "Tersedia",
    assign: "Pasang",
    unassign: "Lepas",
    move_up: "Naik",
    move_down: "Turun",
    no_available: "Tidak ada lagi yang bisa dipasang",
    no_assigned: "Belum ada yang dipasang",
    unassigned: "Belum dipasang",
    exclude_items: "Kecualikan item",
    excluded_items: "dikecualikan",
    excluded_items_count: "Item dikecualikan",
    excluded: "Dikecualikan",
    no_excluded: "Tidak ada item yang dikecualikan",
    exclude_items_hint: "Item yang dikecualikan dihilangkan dari checklist tipe ini. Kategori kendaraan tetap menentukan kumpulan item.",
    select_unit_and_type_hint: "Pilih kendaraan/aset dan tipe inspeksi untuk memuat checklist.",
    change_scope_title: "Buang jawaban saat ini?",
    change_scope_desc: "Mengubah site, kendaraan, atau tipe inspeksi akan membuang status item, catatan, foto, dan catatan umum. KM/HM tetap disimpan.",
    discard_answers: "Buang jawaban",
    vin: "VIN",
    categories_count: "Kategori",
    items_count: "Item",
    no_categories_hint: "Unit ini belum memiliki kategori inspeksi. Minta admin memasang kategori.",
    take_photo: "Ambil foto",
    capture: "Jepret",
    retake: "Ulangi",
    use_photo: "Gunakan foto",
    camera_error: "Kamera tidak tersedia. Izinkan akses kamera.",
    flash: "Lampu kilat",
    flash_on: "Lampu kilat nyala",
    flash_unavailable: "Lampu kilat tidak tersedia di kamera ini.",
    compressing: "Memproses...",
    all_items: "Semua item",
    defect_items: "Item temuan",
    photos_purged: "Foto telah dihapus setelah masa simpan 3 bulan; data inspeksi tetap tersimpan.",
    items_flagged: "item ditandai",
    default_ok_hint: "Semua item dimulai sebagai OK — ubah status hanya jika menemukan masalah.",
    photo_optional: "Foto (opsional)",
    my_inspections: "Inspeksi Saya",
    draft: "Draf",
    save_progress: "Simpan progres",
    saving_progress: "Menyimpan...",
    progress_saved: "Progres disimpan di perangkat ini",
    continue_draft: "Lanjutkan",
    delete_draft: "Hapus draf",
    discard_draft: "Buang draf",
    drafts_on_device: "Draf di perangkat ini",
    draft_missing: "Draf tidak ditemukan di perangkat ini",
    leave_inspection_title: "Simpan inspeksi ini?",
    leave_inspection_desc: "Anda memiliki inspeksi yang sedang diisi. Simpan draf di perangkat ini, atau buang.",
    save_draft: "Simpan draf",
    draft_resumed: "Draf dipulihkan di perangkat ini",
    gps_unavailable: "GPS tidak tersedia",
    gps_insecure: "GPS membutuhkan HTTPS. Buka situs dengan https, atau gunakan aplikasi Android.",
    msnm: "msnm",
  },
};

export const STATUS_CODES = ["OK", "NOT_OK", "KOROSI", "KURANG", "LONGGAR"];

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("dt_lang") || "en");
  const setLang = useCallback((l) => {
    localStorage.setItem("dt_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((k) => dict[lang]?.[k] ?? dict.en[k] ?? k, [lang]);
  useEffect(() => {
    document.title = `${t("app_name")} · Inline Technology`;
  }, [t]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useT = () => useContext(LangCtx);
